import { render, staticRenderFns } from "./IconBackArrow.vue?vue&type=template&id=2fdba4d6&scoped=true&"
var script = {}
import style0 from "./IconBackArrow.vue?vue&type=style&index=0&id=2fdba4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdba4d6",
  null
  
)

export default component.exports